export enum ContractSearchPeriodType {
  ALL = 'ALL',
  START = 'START',
  END = 'END'
}

export enum ContractSearchStatusType {
  ALL = 'ALL',
  CONTRACT = 'CONTRACT',
  CHARGE = 'CHARGE'
}

export enum ContractStatus {
  READY = 'READY',
  USE = 'USE',
  FINISH = 'FINISH',
  STOP = 'STOP',
  UNKNOWN = 'UNKNOWN'
}

export enum AutoRenewal {
  AUTO = 'AUTO',
  MANUAL = 'MANUAL'
}

export type ChargeStatus = Exclude<ContractStatus, ContractStatus.STOP | ContractStatus.UNKNOWN>;

export const CONTRACT_SEARCH_PERIOD_TYPE = {
  [ContractSearchPeriodType.ALL]: '전체',
  [ContractSearchPeriodType.START]: '계약시작일',
  [ContractSearchPeriodType.END]: '계약종료일'
} as const;

export const CONTRACT_SEARCH_STATUS_TYPE = {
  [ContractSearchStatusType.ALL]: '전체',
  [ContractSearchStatusType.CONTRACT]: '계약상태',
  [ContractSearchStatusType.CHARGE]: '과금상태'
} as const;

export const CONTRACT_STATUS = {
  [ContractStatus.READY]: '이용대기',
  [ContractStatus.USE]: '이용중',
  [ContractStatus.FINISH]: '만료',
  [ContractStatus.STOP]: '이용정지',
  [ContractStatus.UNKNOWN]: '정의되지않음'
} as const;

export const CHARGING_STATUS: Record<ChargeStatus, string> = {
  [ContractStatus.READY]: '과금예정',
  [ContractStatus.USE]: '과금중',
  [ContractStatus.FINISH]: '과금종료'
} as const;

export const AUTO_RENEWAL = {
  [AutoRenewal.AUTO]: '자동연장',
  [AutoRenewal.MANUAL]: '직접연장'
};
